import * as utils from '../utils'
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/algolia-min.css';

export default {
    name: 'AccountHolderPage',
  
    props: ['appId', 'apiKey'],
  
    data() {
        return {
            searchClient: algoliasearch(
                this.appId,
                this.apiKey
            ),
            query:'',
        }
    },
  
    components: {
    },
  
    computed: {
      
    },
  
    methods: {
        onPageChange(page) {
            $('html, body').animate({
                scrollTop: 0
            }, 500);
            // window.scrollTo(0,0);
        },
        onSubmit() {
            console.log('onSubmit');
        },
        test() {
            console.log('asdasd');
        }
    },
  
    created() {
        this.query = utils.getParameterByName('q');
    },
  
    mounted(){
        console.info(`loading ${this.$options.name}`);
    }
}


// WEBPACK FOOTER //
// ./js/pages/AccountHolderPage.js